import useGetDetailItem from "@hooks/Webinar/useGetWebinar";
import Detail from "@shared/FormTemplates/Detail";
import { ReactElement } from "react";
import DetailForm from "./DetailForm";

const DetailItem = (): ReactElement => (
  <Detail CustomForm={DetailForm} detailHook={useGetDetailItem} />
);

export default DetailItem;
